import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Translation from '../../../../components/stateless/Translation';
import styles from './styles.scss';

const SMFacilitiesListItemBanner = ({ facility }) => {
  const { settings: { bannerToken } } = facility;

  if (!bannerToken) {
    return null;
  }

  return (
    <div
      className={`${styles.banner} text-white font-bold bg-banner px-2 py-1 font-normal capitalize absolute z-10 -left-2 top-2`}
      data-testid="sm-facilities-list-item-banner"
    >
      <Translation
        id={`enterprise.widgets.storageMartFacilityList.${bannerToken}`}
        defaultMessage="Exclusive Online Discounts"
      />
    </div>
  );
};

SMFacilitiesListItemBanner.propTypes = {
  facility: PropTypes.shape({
    settings: PropTypes.shape({
      bannerToken: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

SMFacilitiesListItemBanner.fragments = {
  facility: gql`
    fragment SMFacilitiesListItemBannerFacility on Facility {
      id
      settings {
        bannerToken
      }
    }
  `,
};

export default SMFacilitiesListItemBanner;
